import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import {
  APPOINTMENT_TEXT,
  APPOINTMENT_TITLE,
  CONTACT_STORE_TITLE,
  PHONE_TEXT,
  SELECT_STORE_TEXT
} from './constants'
import { formatPhoneNumber } from 'helpers/phone-number'
import Media from 'components/common/Media'
import { H2, H3 } from '../common/Text/Text'

const BOTStoreContactPage = ({
  storePhoneNumber,
  onClick,
  simulateCall,
  handleStoreLocationClick
}) =>
  <Wrapper>
    <Subtitle headline_narrow>
      Need help?
    </Subtitle>
    <TilesWrapper>
      <TileWrapper onClick={ onClick }>
        <IconComponent asset="book-appointment-red" height={ 37 } width={ 37 } />
        <TileTitle headline_narrow>
          {APPOINTMENT_TITLE}
        </TileTitle>
        <Text>
          {APPOINTMENT_TEXT}
        </Text>
        <ArrowIcon asset="arrow-right" height={ 37 } width={ 37 } />
      </TileWrapper>
      {storePhoneNumber ? (
        <TileWrapper onClick={ simulateCall }>
          <IconComponent asset="icon-account-bright-red" height={ 37 } width={ 37 } />
          <TileTitle headline_narrow>
            {CONTACT_STORE_TITLE}
          </TileTitle>
          <PhoneWrapper>
            <Text>{PHONE_TEXT}</Text>
            <StorePhoneNumber>
              {formatPhoneNumber(storePhoneNumber)}
            </StorePhoneNumber>
          </PhoneWrapper>
          <ArrowIcon asset="arrow-right" height={ 37 } width={ 37 } />
        </TileWrapper>
      ) : (
        <TileWrapper onClick={ handleStoreLocationClick }>
          <IconComponent asset="icon-account-bright-red" height={ 37 } width={ 37 } />
          <TileTitle headline_narrow>
            {CONTACT_STORE_TITLE}
          </TileTitle>
          <PhoneWrapper>
            <Text>{PHONE_TEXT}</Text>
            <StorePhoneNumber>
              {SELECT_STORE_TEXT}
            </StorePhoneNumber>
          </PhoneWrapper>
          <ArrowIcon asset="arrow-right" height={ 37 } width={ 37 } />
        </TileWrapper>
      )}

    </TilesWrapper>
  </Wrapper>

export default BOTStoreContactPage

BOTStoreContactPage.propTypes = {
  handleStoreLocationClick: PropTypes.func,
  onClick: PropTypes.func,
  simulateCall: PropTypes.func,
  storePhoneNumber: PropTypes.string
}

const Wrapper = styled.div`
  width: calc(100vw - 18px);
  max-width: 100vw;
  margin-top: 70px;
  margin-left: calc(50% - 50vw + 9px);
  padding: 45px 16px 45px;
  background: #f2f2f2;
`

const Subtitle = styled(H2)`
  margin: 0 0 25px 0;
  text-transform: uppercase;
  ${Mixin.font.GothamBold()}
  text-align: center;
  font-size: 24px;
`

const TilesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 830px;
  margin: 0 auto;
  ${Media.mobile`
    flex-direction: column;
    align-items: center;
  `}
`

const TileWrapper = styled.div`
  position: relative;
  width: 400px;
  height: 190px;
  padding: 35px 86px 35px 48px;
  border-radius: 6px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  background: ${Theme.colors.white};
  cursor: pointer;
  ${Media.mobile`
    height: auto;
    width: 100%;
    max-width: 355px;

    &:nth-child(2) {
      margin: 30px 0 0 0;
    }
  `}
`

const IconComponent = styled(Icon)`
  margin: 0 0 16px;
`

const ArrowIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 48px;
  height: 19px;
  transform: translate(0, -50%);
`

const TileTitle = styled(H3)`
  margin: 0 0 10px;
  letter-spacing: 0.03em;
  ${Mixin.font.GothamBold(16)}
  text-transform: uppercase;
  font-stretch: condensed;
  ${Media.mobile`
    font-size: 14px;
  `}
`

const Text = styled.p`
  margin: 0;
  max-width: 270px;
  ${Mixin.font.GothamMedium(14)}
  color: ${Theme.colors.off_medium_grey};
  ${Media.mobile`
    font-size: 12px;
  `}
`

const PhoneWrapper = styled.div`
  display: flex;
  align-items: center;
`

const StorePhoneNumber = styled.p`
  margin: 0 0 0 5px;
  color: ${Theme.colors.blue};
  font-size: 16px;
  ${Mixin.font.GothamBold()}
`
